import {fieldset, textfield} from "@intermesh/goui";

import {FormWindow} from "@intermesh/groupoffice-core";
import {t} from "./Translate";

export class FormBookWindow extends FormWindow {

	constructor() {
		super("FormBook");

		this.title = t("Form book");
		this.stateId = "form-book-dialog";
		this.maximizable = true;

		this.height = 600;

		this.generalTab.items.add(

			fieldset({},

				textfield({
					flex: 2,
					name: "name",
					label: t("Name"),
					required: true
				})
			)
		);

		this.addSharePanel();
	}


}


